import React from 'react';
import { Box, Container, Grid, Typography, Link, Divider, useTheme, useMediaQuery } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: 'primary.main', 
        color: 'white',
        py: { xs: 4, md: 6 },
        mt: 'auto',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
      }}
    >
      <Container maxWidth="lg">
        <Grid 
          container 
          spacing={{ xs: 4, md: 8 }} 
          sx={{ 
            justifyContent: 'space-between',
            '& > .MuiGrid-item': {
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' }
            }
          }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                mb: 2,
                width: '100%',
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Contact Us
            </Typography>
            <Box sx={{ 
              mb: 2, 
              lineHeight: 1.8,
              textAlign: { xs: 'center', md: 'left' }
            }}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                MGI Building Opposite KDP Grand Savanna, Raj Nagar Extension 
                <br />
                Ghaziabad, U.P 201017
              </Typography>
              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Phone:</strong> (+91) 9455133862
              </Typography>
              <Typography variant="body2">
                <strong>Email:</strong> priyanka@getyoursolution.in
              </Typography>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                mb: 2,
                width: '100%',
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Practice Areas
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: 1.5,
              alignItems: { xs: 'center', md: 'flex-start' }
            }}>
              <Link 
                component={RouterLink} 
                to="/services" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Corporate Law
              </Link>
              <Link 
                component={RouterLink} 
                to="/services" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Intellectual Property
              </Link>
              <Link 
                component={RouterLink} 
                to="/services" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Business Litigation
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={4}>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                mb: 2,
                width: '100%',
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Quick Links
            </Typography>
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: 1.5,
              alignItems: { xs: 'center', md: 'flex-start' }
            }}>
              <Link 
                component={RouterLink} 
                to="/about" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                About Us
              </Link>
              <Link 
                component={RouterLink} 
                to="/contact" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Contact
              </Link>
              <Link 
                component={RouterLink} 
                to="/services" 
                color="inherit" 
                sx={{ 
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline'
                  }
                }}
              >
                Services
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: { xs: 3, md: 4 }, borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between', 
          alignItems: 'center',
          gap: 2
        }}>
          <Typography variant="body2" sx={{ textAlign: { xs: 'center', md: 'left' } }}>
            © {new Date().getFullYear()} Legal Firm. All rights reserved.
          </Typography>
          <Box sx={{ 
            display: 'flex', 
            gap: { xs: 2, md: 3 },
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            <Link 
              component={RouterLink} 
              to="/privacy" 
              color="inherit" 
              sx={{ 
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Privacy Policy
            </Link>
            <Link 
              component={RouterLink} 
              to="/terms" 
              color="inherit" 
              sx={{ 
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;